// extracted by mini-css-extract-plugin
export default {"menuList":"SettingsMenu_menuList__XL7F7"};